import React from "react";
import { GeoJSONLayer } from "./geo-json-layer.component";
import { KmlLayer } from "./kml-layer.component";
import { ShapefileLayer } from "./shapefile-layer.component";

export const MapLayer = ({ data }) => {
  switch (data?.data_type) {
    // case "shapefile":
    //   return (
    //     <ShapefileLayer data={data} />
    //   );

    // case "kml":
    //   return (
    //     <KmlLayer data={data} />
    //   );

    case "geojson":
    default:
      return <GeoJSONLayer data={data} />;
  }
};
